<template>
  <div class="space-bottom">
    <template v-if="!isShowing">
      <a
        href="#"
        class="is-uppercase is-size-7"
        data-cy="show-inputs"
        @click="toggle"
      >Show input...</a>
    </template>
    <template v-else>
      <p>
        <a
          class="is-uppercase is-size-7"
          @click="toggle"
        >Hide input</a>
      </p>
      <slot />
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowing: false,
    };
  },
  methods: {
    toggle() {
      this.isShowing = !this.isShowing;
    },
  },
};
</script>

<style scoped>
div.space-bottom {
  margin-bottom: 1em;
}
</style>
